<template>
  <div class="chartge">
    <div class="charge_title">手机充电</div>
    <div class="charge_content">
      <div
        class="charge_item charge_item1"
        v-if="priceList[1][0]"
        @click="getPaymentParams(priceList[1][0])"
      >
        <div class="charge_item_L">
          <div class="time" v-if="priceList[1][0].time_one">
            {{ priceList[1][0].time_one }}分钟
          </div>
          <div class="des">轻享基础价</div>
        </div>
        <div class="charge_item_R charge_item_R1">
          ￥{{ priceList[1][0].money_one }}
        </div>
      </div>
      <div
        class="charge_item charge_item2"
        v-if="priceList[1][1]"
        @click="getPaymentParams(priceList[1][1])"
      >
        <div class="charge_item_L">
          <div class="time" v-if="priceList[1][1].time_one">
            {{ priceList[1][1].time_one }}分钟
          </div>
          <div class="des">优享性价比</div>
        </div>
        <div class="charge_item_R charge_item_R2">
          ￥{{ priceList[1][1].money_one }}
        </div>
      </div>
      <div
        class="charge_item charge_item3"
        v-if="priceList[1][2]"
        @click="getPaymentParams(priceList[1][2])"
      >
        <div class="charge_item_L">
          <div class="time" v-if="priceList[1][2].time_one">
            {{ priceList[1][2].time_one }}分钟
          </div>
          <div class="des">畅充无忧价</div>
        </div>
        <div class="charge_item_R charge_item_R3">
          ￥{{ priceList[1][2].money_one }}
        </div>
      </div>
      <div
        class="charge_item charge_item4"
        v-if="priceList[1][3]"
        @click="getPaymentParams(priceList[1][3])"
      >
        <div class="charge_item_L">
          <div class="time" v-if="priceList[1][3].time_one">
            {{ priceList[1][3].time_one }}分钟
          </div>
          <div class="des">物超所值档</div>
        </div>
        <div>
          <div class="charge_item_R charge_item_R4">
            <div>￥{{ priceList[1][3].money_one }}</div>
          </div>
          <div class="tips">（另赠1小时=3小时）</div>
        </div>
      </div>
      <div
        class="charge_item charge_item4"
        v-if="priceList[1][4]"
        @click="getPaymentParams(priceList[1][4])"
      >
        <div class="charge_item_L">
          <div class="time" v-if="priceList[1][4].time_one">
            {{ priceList[1][4].time_one }}分钟
          </div>
          <!-- <div class="des"></div> -->
        </div>
        <div>
          <div class="charge_item_R charge_item_R4">
            <div>￥{{ priceList[1][4].money_one }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "WorkspaceJsonCharge",

  data() {
    return {
      // 价格表
      priceList: {
        1: [],
      },
      equ_no: "",
      priceCopyList: {
        1: [
          { money_one: "0.01", time_one: "30" },
          { money_one: "0.01", time_one: "60" },
          { money_one: "0.01", time_one: "90" },
          { money_one: "0.01", time_one: "180" },
        ],
        2: [],
      },
    };
  },

  mounted() {
    // 获取套餐价格
    this.getPriceList();
  },

  methods: {
    // 获取套餐价格接口
    async getPriceList() {
      try {
        const res = await axios.get(
          "https://htapi.zxznzy.com/project/get_money_list",
          {
            params: {
              equ_id: localStorage.getItem("text"),
            },
          }
        );
        if (res.data.code === 200) {
          this.priceList = res.data.pro_money_list[0].money_list || { 1: [] }; // 兜底空数组
          this.project_no = res.data.pro_money_list[0].project_no;
          this.equ_no = res.data.pro_money_list[0].equ_no;
          if (this.equ_no == "50000000134") {
            this.priceList = this.priceCopyList;
          }
        }
      } catch (err) {
        console.error("获取价格列表失败:", err);
      }
    },
    // 获取支付参数
    async getPaymentParams(itemObj) {
      axios({
        method: "post",
        url: "https://htapi.zxznzy.com/project/wx_pay_h5",
        data: {
          equ_no: this.equ_no,
          equ_id: localStorage.getItem("text"),
          project_no: this.project_no,
          equ_price: itemObj.money_one, // 金额
          open_minus: itemObj.time_one, // 时长
          price_type: "1", // 类型 充电1  套餐2
          open_id: localStorage.getItem("open_id"),
        },
      })
        .then((response) => {
          if (response.data.code == 200) {
            // alert("获取支付参数" + JSON.stringify(response.data));
            this.onBridgeReady(response.data);
          } else {
            this.$message.error("error get opneid2");
            throw new Error(response.data.errmsg || "未知错误");
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },

    /* eslint-disable */
    async onBridgeReady(params) {
      try {
        // 添加请求超时处理
        const timer = setTimeout(() => {
          alert("支付超时，请刷新页面重试");
        }, 10000); // 10秒超时

        WeixinJSBridge.invoke("getBrandWCPayRequest", params, (res) => {
          clearTimeout(timer);

          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 跳转到订单列表
            this.$router.push({ path: "/orderList" });
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            alert("您已取消支付，可到订单页面重新支付");
          } else {
            alert(`支付失败: ${res.err_msg || "未知错误"}`);
          }
        });
      } catch (error) {
        alert("系统繁忙，请稍后重试 (CODE:500)");
      }
    },
    /* eslint-enable */
  },
};
</script>

<style lang="scss" scoped>
.chartge {
  background: linear-gradient(to bottom, #e3faf4, #fff);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  padding: 10px 30px 0;
  box-sizing: border-box;
  .charge_title {
    font-family: FZLanTingHeiS-DB-GB;
    font-weight: 400;
    font-size: 17px;
    color: #000000;
    text-align: center;
  }
  .charge_content {
    width: 100%;
    height: 80vh;
    .charge_item {
      width: 100%;
      height: 14vh;
      margin-top: 20px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 26px 0 24px;
      box-sizing: border-box;
      .charge_item_L {
        .time {
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          font-size: 27px;
          color: #ffffff;
        }
        .des {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
      }
      .charge_item_R {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 27px;
        color: #ffffff;
        padding: 2px 10px;
        border-radius: 30px;
      }
    }
    .charge_item1 {
      background: #91e6c6;
      .charge_item_R1 {
        background: #0ec281;
      }
    }
    .charge_item2 {
      background: #a3daf8;
      .charge_item_R2 {
        background: #47b7fb;
      }
    }
    .charge_item3 {
      background: #fdbc8b;
      .charge_item_R3 {
        background: #fa893c;
      }
    }
    .charge_item4 {
      background: #d5c7f9;
      .charge_item_R4 {
        background: #b081fb;
        width: 4rem;
        margin-left: auto;
      }
      .tips {
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 13px;
        color: #7145b7;
        margin-top: 6px;
      }
    }
  }
}
</style>
